const AccountQueryKey = {
  BANK: 'BANK',
  ACCOUNT: 'ACCOUNT',
  ACCOUNT_VERIFY: 'ACCOUNT_VERIFY',
};

export default AccountQueryKey;
